import apiHandler from "../../../../api/core/apiHandler";

const receivablePaymentApi = apiHandler("receivable/payments");

export default receivablePaymentApi;